const observer = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    if (mutation.type === "childList") {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && node.matches('span')) {
          handleVariantChange(node);
        }
      });

      // 👇 Check preorder every time nodes are added
      checkPreorderStatus();
    }

    if (mutation.type === "characterData") {
      const node = mutation.target.parentElement;
      if (node && node.matches('span')) {
        handleVariantChange(node);
        checkPreorderStatus();
      }
    }
  }
});

function handleVariantChange(el) {
  const variantName = el.textContent.trim();
  const normalized = variantName.replace(/\s+/g, "-");
  const expectedId = `${normalized}__images`;

  const targetWrapper = document.getElementById(expectedId);
  if (targetWrapper) {
    // Reset all wrappers
    document.querySelectorAll(".product-color_image-wrapper").forEach((wrapper) => {
      wrapper.classList.remove("is--image--active");
      wrapper.style.display = "none";
    });

    // Activate matched wrapper
    targetWrapper.classList.add("is--image--active");
    targetWrapper.style.display = "flex"; // or "block"
  }
}

// observe product areas
const productMainList = document.querySelectorAll(".product-color-area");
productMainList.forEach((area) => {
  observer.observe(area, {
    childList: true,
    subtree: true,
    characterData: true,
  });
});

// 🔑 Centralized preorder check
function checkPreorderStatus() {
  const preSaleButton = document.querySelector('.button[value="Preorder Now"]');
  const preOrderDate = document.querySelector('.pre-order');
  const allProdDate = document.querySelector('.date:not(.pre-order)');

  if (!preOrderDate || !allProdDate) return;

  if (preSaleButton) {
    preOrderDate.classList.remove('hidden');
    allProdDate.classList.add('hidden');
  } else {
    preOrderDate.classList.add('hidden');
    allProdDate.classList.remove('hidden');
  }
}

// initial run
document.addEventListener("DOMContentLoaded", function() {
  checkPreorderStatus();

  // 👇 Also observe body for preorder button injection
  const preorderObserver = new MutationObserver(checkPreorderStatus);
  preorderObserver.observe(document.body, { childList: true, subtree: true });
});
